import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { BusinessProvider } from '~/common/providers/business';

import { ToastProvider } from './toast';
import { MonteiroEngenhariaThemeProvider } from './theme';
import { PlatformAuthProvider } from './platform-auth';
import { AuthProvider } from './auth';
import { GlobalStyle } from '../styles/global';
import { IFCWithChildren } from '../interfaces/i-fc-with-children';

export const ProvidersHOC: IFCWithChildren = ({ children }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <MonteiroEngenhariaThemeProvider>
        <BusinessProvider>
          <ToastProvider>
            <GlobalStyle />
            <AuthProvider>
              <PlatformAuthProvider>{children}</PlatformAuthProvider>
            </AuthProvider>
          </ToastProvider>
        </BusinessProvider>
      </MonteiroEngenhariaThemeProvider>
    </QueryClientProvider>
  );
};
